import { defineComponent as _defineComponent } from 'vue'
import { emptyPaged, Paged } from '@/services/pagination';
import moment from 'moment';
import { EventData, ImportantMessageLevel } from '@/models/Charts/chartsData';
import EventsTableExpandedView from '@/components/careConsole/EventsTableExpandedView.vue';
import { FilterTimeAxisSpanEnum } from '@/models/enums/FilterTimeAxisSpanEnum';
import { addDataTestIdAttributeToTh } from '@/utils/table';
import { SortOrder } from '@/models/enums/SortOrder';
import { computed, getCurrentInstance, onMounted, ref } from 'vue';
import { useI18n } from '@/composables/i18n';
import { modalService } from '@/library-services/modal.service';
import { isNil } from '@/utils/misc';
import { useRoute } from '@/composables/router';


/** @deprecated THIS COMPONENT IS FROZEN **/
const __default__ = {};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'EventsTable',
  props: {
    pagedEvents: null,
    deviceId: null,
    dateRange: null,
    dateGrouping: { default: FilterTimeAxisSpanEnum.Day },
    modules: { default: () => [] },
    eventTypes: { default: () => [] },
    eventCodes: { default: () => [] },
    rowsPerPage: { default: 10 },
    defaultSortField: { default: 'timestamp' },
    defaultSortOrder: { default: SortOrder.Descending },
    expandable: { type: Boolean, default: false },
    loading: { type: Boolean, default: false }
  },
  emits: ["page-change", "sort", "click"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'page-change', value: number): void;
  (e: 'sort', field: string, order: SortOrder): void;
  (e: 'click', value: EventData): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { pagedEvents: Paged<EventData> | null, deviceId: string, dateRange: [string, string], dateGrouping: FilterTimeAxisSpanEnum, modules: string[], eventTypes: ImportantMessageLevel[], eventCodes: string[], rowsPerPage: number, defaultSortField: string, defaultSortOrder: SortOrder, expandable: boolean, loading: boolean };





const route = useRoute();
const { t } = useI18n();

const app = getCurrentInstance();
const sortField = ref('timestamp');
const sortOrder = ref<SortOrder>(SortOrder.Descending);

onMounted(() => {
  sortField.value = props.defaultSortField;
  sortOrder.value = props.defaultSortOrder;
});

function onExpandClicked() {
  modalService.compositionApi.open(
    {
      component: EventsTableExpandedView,
      width: '98vw',
      canCancel: ['escape', 'outside'],
      props: {
        deviceId: props.deviceId,
        selectedTimeFilter: props.dateRange,
        routeParams: route.value.params,
        dateGrouping: props.dateGrouping,
        defaultSortField: sortField.value,
        defaultSortOrder: sortOrder.value,
        paramValues: {
          eventModules: props.modules,
          eventTypes: props.eventTypes,
          eventCodes: props.eventCodes,
        },
      },
    },
    app,
  );
}

function formatTimestamp(isoDate: string) {
  switch (props.dateGrouping) {
    case FilterTimeAxisSpanEnum.None:
      return moment(isoDate).format('YYYY-MM-DD, HH:mm:ss');
    case FilterTimeAxisSpanEnum.Hour:
      return moment(isoDate).format('YYYY-MM-DD, HH:mm');
    default:
      // The format is already ok for the rest of groupings and no time zone
      // change is needed either.
      return isoDate;
  }
}

function formatFirstLastTimestamp(isoDate: string) {
  return moment(isoDate).format('YYYY-MM-DD, HH:mm:ss');
}

function onSort(field: string, order: SortOrder) {
  sortField.value = field;
  sortOrder.value = order;
  emit('sort', sortField.value, sortOrder.value);
}

const isGroupingByDate = computed<boolean>(
  () => props.dateGrouping !== FilterTimeAxisSpanEnum.None,
);

const valueOrDefault = computed<Paged<EventData>>(() =>
  isNil(props.pagedEvents) ? emptyPaged<EventData>() : props.pagedEvents,
);

return { __sfc: true,props, emit, route, t, app, sortField, sortOrder, onExpandClicked, formatTimestamp, formatFirstLastTimestamp, onSort, isGroupingByDate, valueOrDefault, addDataTestIdAttributeToTh }
}

})